import React from 'react';
import { Typography } from '@hmsexp/component-library';
 
const LowerSampleSizeFooter = ({ size }) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        marginTop: 16,
      }}>
      <div
        style={{
          position: 'relative',
          width: 12,
          height: 12,
          borderRadius: '50%',
          border: '1.5px solid #D32F2F',
          overflow: 'hidden',
          flexShrink: 0
        }}>
        <div
          style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: '50%',
            backgroundColor: '#D32F2F'
          }}
        />
      </div>
 
      <Typography variant='caption' fontWeightType='regular' style={{ color: '#1F1F1F' }}>
        Low sample size &lt; {size}
      </Typography>
    </div>
  );
};
 
export default LowerSampleSizeFooter;